@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-modal-transaction-discover/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@adv-mt/mt-modal-transaction-confirmed-basic/lib/index';
@import '~@adv-mt/mt-modal-basic-content/lib/index';
@import '~@adv-mt/mt-messaging/lib/index';
@import '../components/index.scss';
@import '../InfoArea/InfoArea.scss';

$bd-user-messages-msg-list-item: 2px solid transparent;
$bd-user-messages-msg-list-item--selected: 2px solid $c-primary;

$lh-user-messages-msg-list-edit-bar-actions-button: 24px;
$o-user-messages-msg-list-edit-bar-actions-button: 1px solid $c-primary;

$bgsz-user-messages-thumb-not-available: 60px;
$bgsz-user-messages-thumb-not-available-small: 48px;

$h-user-messages-feature-not-available-modal-content-header: 88px;
$h-user-messages-msg-input-textarea: calc($p-m + 24px + $p-m);
$h-user-messages-msg-list-item: calc(2px + $p-l + 64px + $p-l + 2px);
$h-user-messages-msg-icons-input-first-line-wrapper: 40px;
$r-user-messages-control-settings: 8px;

$mh-messaging-header-thumb: 48px;
$mw-messaging-header-username: 240px;

$o-user-messages-msg-list-item: 1px solid $c-neutral;

$op-disabled: 0.4;
$w-user-messages-msg-icons-input-first-line-wrapper: 40px;

// Needed to be defined at root in order to
// overwrite the widget modal
* {
  --messages-anchor-main-bgcolor: #{$c-gray-light-1};
  --msg-border_radius-container: #{$bdrs-l};
  --msg-border_radius-pill_small: #{$bdrs-l};
  --msg-border_radius: #{$bdrs-l};
  --msg-color-dark: #{$c-primary};
  --msg-color-header_background: #{$c-white};
  --msg-color-header_font: #{$c-primary};
  --msg-color-light: #{$c-primary-light-4};
  --msg-color-main_light: #{$c-primary-light-4};
  --msg-color-main: #{$c-primary};
  --msg-color-medium: #{$c-gray-light-1};
  --msg-spacing-normal: #{$p-l};
}

body:has(.mt-UserMessages):has(.messaging):has(.msg-layout):has(.msg-header) {
  overflow: hidden;

  // required when a conversation is opened on mobile
  #root {
    overflow: hidden;
    max-height: 100vh;
  }
}

.mt-UserMessages {
  display: flex;
  flex-direction: column;
  gap: $m-l;

  @include media-breakpoint-up(l) {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @include media-breakpoint-up(l) {
      position: relative;
    }
  }

  &-widget {
    flex-grow: 1;
    margin: 0;
    padding: 0;
    position: unset !important;

    @include media-breakpoint-up(l) {
      max-height: 100%;
      position: absolute !important;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .msg {
      &-attachment {
        &_system {
          &_message {
            &_text {
              font-size: $fz-l;
              font-weight: $fw-semi-bold;
              line-height: $lh-l;
              text-align: left;
            }
            &_link {
              font-size: $fz-l;
              font-weight: $fw-semi-bold;
              line-height: $lh-l;
              justify-content: flex-start;
              text-decoration: underline;

              &_container {
                border-top: none;
                padding: 0 $p-l $p-l;
              }
            }
            &_subtext {
              border-top: none;
              color: $c-primary;
              font-size: $fz-l;
              font-weight: $fw-regular;
              line-height: $lh-l;
              padding: $p-m $p-l $p-l;
              text-align: left;
            }
          }
        }
        &__system {
          &_extensibility {
            &_header {
              font-size: $fz-l;
              font-weight: $fw-semi-bold;
              line-height: $lh-l;
            }
            &_link {
              font-size: $fz-l;
              font-weight: $fw-semi-bold;
              line-height: $lh-l;
              justify-content: flex-start;
              text-decoration: underline;

              &_container {
                border-top: none;
                padding: 0 $p-l $p-l;
              }
            }
            &_text {
              border-top: none;
              font-weight: $fw-regular;
              line-height: $lh-l;
              padding: $p-m $p-l $p-l;
              text-align: left;
            }
          }
          &_text {
            display: flex;
            gap: $g-s;
            text-align: left;
          }
        }
      }

      &-chat {
        background-color: $c-white;

        &__bubble {
          &_first-person,
          &_third-person {
            font-size: $fz-l;
            font-weight: $fw-regular;
          }

          &_first-person {
            background-color: $c-info-light;
            border: none;
            color: $c-primary;
          }

          &_third-person {
            background-color: $c-neutral;
            border: none;
            color: $c-primary;
          }
        }

        &__button {
          &--integration {
            background-color: $c-primary;
            border-radius: $bdrs-base * 16;
            color: $c-white;
            font-size: $fz-l;
            font-weight: $fw-semi-bold;
            height: auto;
            line-height: $lh-l;
            padding: $p-m $p-l;
          }
        }

        &__time {
          color: $c-neutral-dark-3;
          font-size: $fz-m;
          font-weight: $fw-regular;

          & > b,
          & > strong {
            font-weight: $fw-regular;
          }
        }
      }

      &-control {
        background-size: unset;

        &_attachment {
          &_icon_clip {
            background-image: url('https://s.ccdn.es/images/common/icons/attach.svg');
            margin: 0;
          }
          &_icon_image {
            background-image: url('https://s.ccdn.es/images/common/icons/image-multiple-outline.svg');
            margin: 0;
          }
        }

        &_close,
        &_close-light {
          background-image: url('https://s.ccdn.es/images/common/icons/close.svg');
        }

        &_settings,
        &_settings-light {
          background-image: url('https://s.ccdn.es/images/common/icons/kebab-menu.svg');
        }
      }

      &-dynamic-wrapper {
        &__components {
          background-image: linear-gradient(0deg, $c-white, transparent);
        }
      }

      &-header {
        min-width: 0;

        &__available {
          &::before {
            background-color: $c-success;
          }
        }

        &__info {
          width: 50%;
        }

        &__link {
          font-weight: $fw-semi-bold;
          margin-bottom: 0;
          max-width: $mw-messaging-header-username;

          @include media-breakpoint-up(l) {
            max-width: 100%;
          }
        }

        &__meta {
          margin-right: $m-xl;

          @include media-breakpoint-up(l) {
            margin-right: unset;
          }
        }

        &__price {
          color: $c-accent;
          font-size: $fz-l;
          font-weight: $fw-semi-bold;
        }

        &__product {
          margin: $m-l;
        }

        &__thumb {
          max-height: $mh-messaging-header-thumb;
          position: absolute;
          left: 0;

          @include media-breakpoint-up(l) {
            left: unset;
            right: 0;
          }
          &_container {
            border-radius: $bdrs-l;
          }
          &_not-available {
            background-color: $c-primary-dim5;
            background-image: url('https://s.ccdn.es/images/illustrations/site-no-image.svg');
            background-size: $bgsz-user-messages-thumb-not-available-small;
          }
        }

        &__title {
          font-size: $fz-m;
          font-weight: $fw-semi-bold;
          padding-right: $p-m;
          margin-bottom: 0;

          @include media-breakpoint-up(l) {
            width: 100%;
          }
        }

        &__username {
          @include media-breakpoint-up(l) {
            padding-right: $p-l;
            width: 50%;
          }
        }
      }

      &-input {
        column-gap: $g-m;

        &__button {
          align-self: center;
          background-color: transparent;
          background-image: url('https://s.ccdn.es/images/common/icons/paperplane-outline--enabled.svg');
          background-position: center;
          background-repeat: no-repeat;
          background-size: $sz-icon-m;
          font-size: 0;
          rotate: 45deg;

          &_disabled {
            background-image: url('https://s.ccdn.es/images/common/icons/paperplane-outline--disabled.svg');
          }
        }

        &__first-line-wrapper {
          align-items: center;
          gap: $g-m;

          & > :nth-child(1),
          & > :nth-child(2) {
            height: $h-user-messages-msg-icons-input-first-line-wrapper;
            width: $w-user-messages-msg-icons-input-first-line-wrapper;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        &__hint-text {
          color: $c-primary-dim1;
          display: none;
          line-height: $lh-l;

          & > b,
          & > strong {
            font-weight: $fw-regular;
          }

          @include media-breakpoint-up(l) {
            display: block;
          }
        }

        &__textarea {
          background-color: $c-white;
          outline: 1px solid $c-gray-light-1;
          font-weight: $fw-regular;
          height: $h-user-messages-msg-input-textarea;
          padding: $p-m $p-l;
          margin: 0;
          &::placeholder {
            color: $c-primary-dim3;
          }
        }
      }

      &-list {
        &__avatar {
          display: none;
        }

        &__checkbox {
          &_container {
            align-items: flex-start;
          }

          &_input {
            &:focus + .msg-list__checkbox_visual_input {
              outline: none;
            }
          }

          &_visual_input {
            background: none;
            background-image: url('https://s.ccdn.es/images/common/icons/checkbox-empty.svg');
            border: none;
            height: $sz-icon-m;
            width: $sz-icon-m;

            &--selected {
              background-image: url('https://s.ccdn.es/images/common/icons/checkbox-filled.svg');
            }

            &--disabled {
              opacity: $op-disabled;
            }
          }
        }

        &__counter {
          background-color: $c-accent;
        }

        &__edit-bar {
          position: sticky;

          &-actions-button {
            border: none;
            border-radius: $bdrs-base * 16;
            font-family: $ff-sans-serif;
            font-size: $fz-l;
            font-weight: $fw-semi-bold;
            line-height: $lh-user-messages-msg-list-edit-bar-actions-button;
            outline: $o-user-messages-msg-list-edit-bar-actions-button;
            padding: $p-s;
          }

          &-delete-icon {
            display: none;
          }

          &-primary {
            &-button {
              font-size: $fz-m;
              font-weight: $fw-semi-bold;
              text-transform: none;
              text-decoration: underline;
            }
          }

          &:after {
            left: 0;
            width: 100%;
          }
        }

        &__thumbnail {
          &_container,
          &_img {
            border-radius: $bdrs-l;
          }
        }

        &__item {
          border: $bd-user-messages-msg-list-item;
          height: $h-user-messages-msg-list-item;
          outline: $o-user-messages-msg-list-item;

          &:hover,
          &.selected {
            background: unset;
          }
          &.selected {
            border: $bd-user-messages-msg-list-item--selected;
            z-index: 1;
          }

          &--bulk-selected,
          &--bulk-selected:not(.selected) {
            background-color: $c-white;
          }

          &--with-checkbox .msg-list__text {
            padding-left: 0;
          }
        }

        &__items {
          margin-top: 0;
        }

        &__message {
          display: -webkit-box;
          font-size: $fz-s;
          font-weight: $fw-regular;
          height: calc($lh-l * 1em);
          line-height: $lh-l;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;

          &_integration_in_progress {
            display: none;
          }
        }

        &__preview {
          margin-top: auto;
        }

        &__product {
          font-size: $fz-s;
          font-weight: $fw-semi-bold;
          line-height: $lh-l;
        }

        &__settings {
          right: $r-user-messages-control-settings;
        }

        &__text {
          display: flex;
          flex-direction: column;
          height: 100%;
          padding: 0;
        }

        &__thumb {
          &_not-available {
            background-color: $c-primary-dim5;
            background-image: url('https://s.ccdn.es/images/illustrations/site-no-image.svg');
            background-size: $bgsz-user-messages-thumb-not-available;
          }
        }

        &__username {
          font-weight: $fw-semi-bold;
          line-height: $lh-m;
        }
      }

      &-layout {
        border: 0;
        border-radius: $bdrs-l;
        box-shadow: $bxsh-m;

        &__left-main {
          margin-top: 0 !important;
          min-width: 0;
        }
      }

      &-empty {
        &__image {
          background-image: url('https://s.ccdn.es/images/empty-case-messages.svg');
        }
      }
    }

    .unread-message-anchor {
      display: none;
    }
  }

  &-skeleton {
    width: 100%;
    background-color: $c-white;
    border-radius: $bdrs-l;
    box-shadow: $bxsh-m;
    margin-top: $m-xl;
  }

  &-featureNotAvailableModal {
    font-size: $fz-l;

    &ContentHeaderImageWrapper {
      align-items: center;
      display: flex;
      gap: $g-m;
      height: $h-user-messages-feature-not-available-modal-content-header;

      &Icon {
        color: $c-primary-dim2;
      }
    }
  }
}
